import { z } from "zod";

export const vehicleMeterTypeValues = ["MILES", "HOURS"] as const;
export const vehicleServiceIntervalUnitValues = ["MILES", "HOURS", "DAYS"] as const;

const nullableNumber = z.number().min(0, "Value must be 0 or greater").nullable().optional();

export const vehicleSchema = z.object({
  name: z.string().trim().min(1, "Vehicle name is required"),
  dailyFormVehicleTypeId: z.string().nullable().optional(),
  year: z.number().int("Year must be a whole number").positive("Year must be greater than 0").nullable().optional(),
  make: z.string(),
  model: z.string(),
  vin: z.string(),
  licensePlate: z.string(),
  registrationState: z.string(),
  registrationExpirationDate: z.string().nullable().optional(),
  inServiceDate: z.string().nullable().optional(),
  meterType: z.enum(vehicleMeterTypeValues).nullable().optional(),
  currentMeterReading: nullableNumber,
  defaultServiceIntervalValue: z
    .number()
    .int("Interval value must be a whole number")
    .min(0, "Interval value must be 0 or greater")
    .nullable()
    .optional(),
  defaultServiceIntervalUnit: z.enum(vehicleServiceIntervalUnitValues).nullable().optional(),
  notes: z.string(),
  isActive: z.boolean(),
});

export type VehicleFormData = z.infer<typeof vehicleSchema>;

export const getDefaultValues = (vehicle?: Partial<VehicleFormData> | null): VehicleFormData => ({
  name: vehicle?.name || "",
  dailyFormVehicleTypeId: vehicle?.dailyFormVehicleTypeId ?? null,
  year: vehicle?.year ?? null,
  make: vehicle?.make || "",
  model: vehicle?.model || "",
  vin: vehicle?.vin || "",
  licensePlate: vehicle?.licensePlate || "",
  registrationState: vehicle?.registrationState || "",
  registrationExpirationDate: vehicle?.registrationExpirationDate ?? null,
  inServiceDate: vehicle?.inServiceDate ?? null,
  meterType: vehicle?.meterType ?? null,
  currentMeterReading: vehicle?.currentMeterReading ?? null,
  defaultServiceIntervalValue: vehicle?.defaultServiceIntervalValue ?? null,
  defaultServiceIntervalUnit: vehicle?.defaultServiceIntervalUnit ?? null,
  notes: vehicle?.notes || "",
  isActive: vehicle?.isActive ?? true,
});
